export * from "./DailyExercisesTable.async";
export * from "./dailyExercisesTable.interface";
